var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5 text-center"},[_c('h3',[_vm._v("Chat")]),(_vm.loading)?_c('div',{staticClass:"spinner-border mt-2",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h3',[_vm._v("En Construcción...")])])
}]

export { render, staticRenderFns }